import axios from 'axios'
import router from '../router'
import rConfig from '@/api/requestConfig'

const service = axios.create({
  // baseURL: 'http://124.71.64.178:4322',
  baseURL: rConfig.baseURL,
  timeout: 5000
})

// 拦截器
service.interceptors.request.use(config => {
  if (window.sessionStorage.getItem('token')) {
    config.headers.token = window.sessionStorage.getItem('token')
  }
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
})
// 响应器
service.interceptors.response.use(
  // 返回值
  response => {
    const res = response
    console.log(parseInt((res.data.code)))
    if (parseInt((res.data.code)) == 300) {
      router.push('/login')
      return res.data
    } else {
      return res.data
    }
    return res.data
  },
  // 403
  error => {
    const res = error


    return res.data
  }
)

export default service


// WEBPACK FOOTER //
// ./src/utils/request.js